import { useEffect, useCallback } from 'react';
import eventBus from './eventBus';

let keyWorks = '';

export const SCANNER_EVENT = 'SCANNER_EVENT';

const BLACK_LIST = [
  'Backquote',
  'Tab',
  'Shift',
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'Control',
  'Alt',
  'Meta',
  'Backspace',
  'Process',
];

function useBarcodeScanner() {
  const KeyDownHandler = useCallback((e) => {
    const key = e.key;
    if (key === 'Enter') {
      if (keyWorks.length > 1) {
        eventBus.emit(SCANNER_EVENT, keyWorks);
      }
      keyWorks = '';
    } else if (!BLACK_LIST.includes(key)) {
      keyWorks += e.key;
    }
  }, []);

  useEffect(() => {
    window.addEventListener('keydown', KeyDownHandler);

    return () => {
      window.removeEventListener('keydown', KeyDownHandler);
    };
  }, []);
}

export default useBarcodeScanner;
